import { Stack } from "@mui/material";
import { LogoMetal, LogoPro } from "../shared/icons";
import { memo } from "react";

export const Logo = memo(({ scale }: { scale?: number }) => {
    return (
        <Stack direction={"row"} alignItems="center" gap={"3px"}>
            <a href='/' style={{ display: 'flex', flexWrap: 'nowrap' }}>
                <LogoPro scale={scale}/>
                <LogoMetal scale={scale}/>
            </a>
        </Stack>
    );
});
